import React, { useEffect, useState } from 'react'
import RightModal from '../../Modals/RightModal'
import { ReactComponent as CloseIcon } from '../../../assets/icons/close.svg';
import InputSelect from '../../InputGroup/InputSelect';
import InputText from '../../InputGroup/InputText';
import InputRupees from '../../InputGroup/InputRupees';
import { bhk_type, unit_type } from '../../../utils/project-constant';
import { insertPricingEOI, updatePricingEOIByUUID } from '../../../services/public/public.service';
import { toast } from 'react-toastify';
import { validityUnit } from '../../../helpers/enums';

const customStyles = {
    control: (base, state) => ({
        ...base,
        boxShadow: "none",
        borderColor: '#ced4da',
        // backgroundColor: '#FAFAFB',
        minHeight: '44px',
        borderRadius: '8px',
        fontSize: '14px',
        fontWeight: '400',
        cursor: 'pointer',
        '&:focus': { borderColor: '#0062ff' },
        // '&:hover': { borderColor: '#ced4da' },
        // You can also use state.isFocused to conditionally style based on the focus state
    }),
    option: (styles, state) => ({
        ...styles,
        fontSize: '14px',
        cursor: 'pointer',
        backgroundColor: state.isSelected ? "#f1f1f5" : styles.color,
        color: state.isSelected ? '#44444F' : '#44444F',
        "&:hover": {
            color: "#44444f",
            backgroundColor: "#f1f1f5"
        }
    }),
};


const AddEOITokenModal = ({ show, closeModal, modalClass, configurations, uuid, getEoiTokenData, selectedPrice, allowedPermissions }) => {
    const [unitTypeAvailble, setUnitTypeAvailable] = useState();
    const [unitConfigurationAvailable, setUnitConfigurationAvailble] = useState();
    const [absoluteAmount, setAbsoluteAmount] = useState();
    const [percentage, setPercentage] = useState();
    const [gstPercentage, setGstPercentage] = useState();
    const [validity, setValidity] = useState();
    const [validity_unit, setValidityUnit] = useState('')
    const [tokenSelection, setTokenSelection] = useState('absolute');
    const [error, setError] = useState(false);

    useEffect(() => {
        if (Object.keys(selectedPrice).length > 0) {
            const unitType = unit_type.filter(item => selectedPrice.unit_type?.includes(item.label));
            const unitConfig = configurations.filter(item => selectedPrice.config?.includes(item.value));
            setUnitTypeAvailable(unitType);
            setUnitConfigurationAvailble(unitConfig);
            setPercentage(selectedPrice.payment_percentage);
            setAbsoluteAmount(selectedPrice.payment_amount);
            setGstPercentage(selectedPrice.gst_percentage);
            if (selectedPrice.payment_amount) {
                setTokenSelection('absolute')
            }
            if (selectedPrice.payment_percentage) {
                setTokenSelection('percent')
            }
        }
    }, [selectedPrice]);

    const handleSubmit = async () => {
        if (!validity || !validity_unit) {
            setError(true);
            return;
        } else {
            setError(false);
        }
        const payload = {
            unit_type: null,
            unit_configuration: unitConfigurationAvailable.map(item => item.value),
            payment_percentage: percentage || null,
            payment_amount: absoluteAmount || null,
            gst_percentage: gstPercentage || null,
            validity: validity || null,
            validity_unit: validity_unit || null
        }

        let res = {};
        if (selectedPrice?.uuid) {
            res = await updatePricingEOIByUUID(selectedPrice.uuid, payload)
        } else {
            res = await insertPricingEOI(uuid, payload);
        }
        if (res.data.status === 200) {
            toast.success(res.data.message);
            getEoiTokenData();
            closeModal();
        }
    }

    const handleClose = () => {
        closeModal();
        setUnitTypeAvailable('');
        setUnitConfigurationAvailble('');
        setAbsoluteAmount('');
        setPercentage('');
        setGstPercentage('');
        setTokenSelection('');
    }


    return (
        <RightModal show={show} closeModal={handleClose} >
            <div className='d-flex justify-content-between border-bottom border-color px-20 py-16'>
                <h1 className='mb-0 black inter fz20 fw-po-medium'>
                    Add EOI Token</h1>
                <button className='border-0 bg-tr ' onClick={handleClose}><CloseIcon /></button>
            </div>
            <div className='d-flex h-100 overflow-auto flex-column !px-5 gap-y-4 !py-5'>

                {/* <InputSelect
                    inputclass='!mt-0'
                    styles={customStyles}
                    label='Unit Type Applicability'
                    isMulti={true}
                    options={unit_type}
                    value={unitTypeAvailble}
                    onChange={(value) => setUnitTypeAvailable(value)}
                /> */}
                <InputSelect
                    inputclass='!mt-0'
                    styles={customStyles}
                    label='Unit Configuration Applicability'
                    value={unitConfigurationAvailable}
                    options={configurations}
                    onChange={(value) => setUnitConfigurationAvailble(value)}
                    isMulti={true}
                />
                <div>
                    <label htmlFor="" className='flex items-center gap-x-2 text-sm text-black700 !mb-2'>EOI Token Value Type
                    </label>
                    <div className='flex gap-x-5'>
                        <label htmlFor="" className='flex items-center gap-x-2 text-sm text-black700 font-medium'>
                            <input type="radio" name="token" id="" value='absolute' checked={tokenSelection === 'absolute'} onChange={() => setTokenSelection('absolute')} />
                            Absolute
                        </label>
                        <label htmlFor="" className='flex items-center gap-x-2 text-sm text-black700 font-medium'>
                            <input type="radio" name="token" id="" value='percent' checked={tokenSelection === 'percent'} onChange={() => setTokenSelection('percent')} />
                            Percentage of Base
                        </label>
                    </div>
                    {tokenSelection === 'percent' &&
                        <InputText
                            placeholder='Enter Percentage'
                            value={percentage}
                            onChange={(e) => setPercentage(e.target.value)}

                        />}
                    {tokenSelection === 'absolute' &&
                        <InputRupees
                            placeholder='Enter Absolute'
                            value={absoluteAmount}
                            onChange={(value) => setAbsoluteAmount(value)}
                            rupayclass='top-4 left-3'
                            handleBlur={() => { }}
                        />
                    }
                </div>
                {/* <div>
                    <label htmlFor="" className='flex items-center gap-x-2 text-sm text-black700 !mb-2'>EOI Token Value Type
                    </label>
                    <div className='flex gap-x-5'>
                        <label htmlFor="" className='flex items-center gap-x-2 text-sm text-black700 font-medium'>
                            <input type="radio" name="" id="" checked />
                            Absolute
                        </label>
                        <label htmlFor="" className='flex items-center gap-x-2 text-sm text-black700 font-medium'>
                            <input type="radio" name="" id="" />
                            Percentage of Base
                        </label>
                    </div>
                    <InputText
                        placeholder='Enter value' />
                </div> */}
                <div>
                    <label htmlFor="">Validity</label>
                    <div className='grid grid-cols-2 gap-2'>
                        <InputText
                            placeholder={'e.g. 30'}
                            value={validity}
                            onChange={(e) => {
                                setValidity(e.target.value)
                            }}
                            disable={!allowedPermissions.includes('edit_eoi_pricing')}
                            error={(error && !validity) ? 'Please enter validity' : ''}
                        />
                        <InputSelect
                            inputclass={'m-0'}
                            styles={customStyles}
                            placeholder={'Select Time'}
                            value={validity_unit ? validityUnit.find(validity => validity.value === validity_unit) : ''}
                            options={validityUnit}
                            onChange={(value) => {
                                setValidityUnit(value.value)

                            }}
                            disable={!allowedPermissions.includes('edit_eoi_pricing')}
                            error={(error && !validity_unit) ? 'Please select validity unit' : ''}
                        />
                    </div>
                </div>
                <InputText
                    label='GST %'
                    placeholder='Enter Percentage'
                    value={gstPercentage}
                    onChange={(e) => setGstPercentage(e.target.value)}
                />
            </div>
            <div className='d-flex flex-row align-items-center justify-content-between !border-t !border-grayLight !px-5 !py-5 gap-x-4'>
                <button type='button' className='outline-btn w-[130px] shrink-0 grow-0 basis-[130px] h-[44px] !text-lg !font-medium !rounded-lg cursor-pointer' onClick={handleClose}>Cancel</button>
                <button type='submit' onClick={handleSubmit} className='pr-btn w-100 h-[44px] !text-lg  !font-medium !rounded-lg cursor-pointer'>Save</button>
            </div>


        </RightModal>
    )
}

export default AddEOITokenModal